export const NON_ID_SUFFIXES = ['cents', 'counts', 'days', 'slots', 'scores', 'series', 'values']

export function isIdField(key: string): boolean {
  return (
    key === 'id' ||
    key === 'ids' ||
    key.endsWith('_id') ||
    key.endsWith('_ids') ||
    key.includes('_id_') ||
    key.includes('_ids_')
  )
}

export function isIdArrayField(key: string): boolean {
  if (key.endsWith('_to_remove')) return true

  if (!key.endsWith('s')) return false

  return NON_ID_SUFFIXES.every((suffix) => !key.toLowerCase().endsWith(suffix))
}

// TODO: Remove after REST API returns string IDs during BigInt migration
export function convertIdsToBigint(obj: unknown): unknown {
  if (Array.isArray(obj)) return obj.map(convertIdsToBigint)

  if (obj && typeof obj === 'object') {
    const result: Record<string, unknown> = { ...obj }
    Object.keys(result).forEach((key) => {
      const value = result[key]
      if (isIdField(key)) {
        if (typeof value === 'number') {
          result[key] = String(value)
        } else if (Array.isArray(value)) {
          result[key] = value.map((v) => (typeof v === 'number' ? String(v) : v))
        }
      } else if (Array.isArray(value)) {
        result[key] = value.map((v) => {
          if (typeof v === 'number' && isIdArrayField(key)) return String(v)
          if (typeof v === 'object' && v !== null) return convertIdsToBigint(v)
          return v
        })
      } else if (typeof value === 'object' && value !== null) {
        result[key] = convertIdsToBigint(value)
      }
    })
    return result
  }
  return obj
}
